import React from 'react';
import PropTypes from 'prop-types';

const LanguageSelector = ({ languages, onLanguageSelection }) => {
  const buttonForLanguage = language => {
    return (
      <button
        className="age-gate__language-selector-button"
        key={language.value}
        value={language.value}
        onClick={onLanguageSelection}
      >
        {language.label}
      </button>
    );
  };

  return (
    <div className="age-gate__language-selector">
      {languages.map(language => buttonForLanguage(language))}
    </div>
  );
};

LanguageSelector.propTypes = {
  languages: PropTypes.arrayOf(PropTypes.object),
  onLanguageSelection: PropTypes.func.isRequired,
};

export default LanguageSelector;
